<template>
    <div class="app_container">
        <div class="videos">
            <div class="video_item" v-for="item in items"
                 :key="item.id">
                <a
                    :onclick="videoClickTrack(item)" :href="item.link.replace('http://', 'https://')">
                    <!-- :style="bg_image(item)" -->
                    <div
                        class="image rc-bg"
                        :data-img-webp="item.image_wp"
                        :data-img-default="item.image" >
                    </div>
                </a>
                <div class="text">
                    <a
                        :onclick="videoClickTrack(item)" class="title" :href="item.link.replace('http://', 'https://')"
                        v-html="item.title">
                    </a>
                </div>
            </div>
        </div>
        <div class="load_more_container">
            <button v-if="limit_reached"
                    @click="load_more_click" class="videos_load_more">
                Load More
            </button>
            <div v-else-if="!end_reached" class="loading"></div>
        </div>
    </div>
</template>

<script>

///////////////////////
// UTILITY FUNCTIONS //
///////////////////////

function getAjax(url, finished) {

    var xhr;
    if (window.XMLHttpRequest) {
        xhr = new XMLHttpRequest();
    } else {
        xhr = new ActiveXObject("Microsoft.XMLHTTP");
    }
    xhr.open('GET', url);
    xhr.onreadystatechange = function () {
        if (xhr.readyState >= 4) {
            if (xhr.status == 200) {
                finished(xhr.responseText);
            } else {
                finished(false);
            }
        }
    };
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send();
    return xhr;
}

function num_with_ordinal_suffix(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}

function daysInMonth(month, year) { // 1 based, not 0 based
    return new Date(year, month, 0).getDate();
}

function pad_num(num, size) {
    var s = "000000000" + num;
    return s.substr(s.length - size);
}

///////////////
// CONSTANTS //
///////////////

var JSON_BASE_URL = '/video/';
var THIS_DATE = new Date();
var EARLIEST_YEAR = 2016;
var EARLIEST_MONTH = 1;
var EARLIEST_DAY = 31;
var MONTH_NAMES = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
var CACHEBUST = new Date().getTime();

import LazyInitBgImages from '../Utility/LazyInitBackgroundImages.js';

export default {
    name: "videos-matrix-widget",
    data: function () {
        return {
            end_reached: false,
            limit_reached: true,
            initial_files_item_num: 0, // Will be set once initial files are loaded
            initial_files: [
                {
                    'name': 'matrix',
                    'url': '/feed/video_political.json', // 12 Matrix
                    'do_file': true,
                    'file_done': false
                }/*,
                {
                    'name' : 'bottom',
                    'url' : '/feed/video_political_bottom.json', // 4 Bottom
                    'do_file' : false,
                    'file_done' : false
                }*/
            ],
            pages_loaded: 0,
            items_per_page: 12,
            concurrent_files: 5,
            files_loaded: 0,
            page_desc: '',
            items: [],
            buffer: [],
            concurrent_buffer: [],
            current_year: THIS_DATE.getFullYear(),
            current_month: THIS_DATE.getMonth() + 1,
            current_day: THIS_DATE.getDate()
        };
    },
    created: function () {
        if (document.querySelectorAll("body.video-landing").length > 0) {
            this.page_desc = 'Video Landing Page';
        } else {
            this.page_desc = 'Video Permalink';
            this.items_per_page = 16;
            // Set 4 bottom file to load
            if (siteName == 'politics') {

                for (var i = 0; i < this.initial_files.length; i++) {

                    if (this.initial_files[i].name == 'bottom') {
                        this.initial_files[i].do_file = true;
                    }
                }
            }
        }
        this.load_more();
    },
    updated(){

        // trigger the lazy loading of bg images every time the HTML is updated
        // and auto choose between webp and default images
        this.$nextTick(() => {
            LazyInitBgImages();
        });

    },
    methods: {

        videoClickTrack: function (item) {

            if (typeof item.id == 'undefined') {
                item.id = 0;
            }

            return "ClickTracking.record_click(event, " + item.id + ", '" + encodeURIComponent(item.title) + "', 'video', 'video-latest-political')";
        },

        load_more: function () {
            this.pages_loaded++;
            this.load_content();
        },

        load_more_click: function () {
            // Google analytics event, then do normal load_more
            var event_data = {
                'ge_action': 'Load More Videos Btn',
                'ge_category': 'Video Pages Event',
                'ge_label': 'Section: ' + this.page_desc,
                'ge_noninteraction': false
            };
            send_ga_event(event_data);

            this.load_more();
        },

        is_limit_reached: function () {
            return this.items.length >= this.pages_loaded * this.items_per_page;
        },

        load_content: function () {

            if (
                this.current_year > EARLIEST_YEAR ||
                (
                    this.current_year == EARLIEST_YEAR &&
                    this.current_month > EARLIEST_MONTH
                ) || (
                    this.current_year == EARLIEST_YEAR &&
                    this.current_month == EARLIEST_MONTH &&
                    this.current_day >= EARLIEST_DAY
                )
            ) {

                // First try loading from buffer. If not enough, do ajax.
                this.limit_reached = this.is_limit_reached();
                if (this.limit_reached) {
                    return;
                }
                var loaded_count = 0;
                for (var i = 0; i < this.buffer.length; i++) {

                    this.items.push(this.buffer[i]);
                    loaded_count++;
                    if (this.is_limit_reached()) {

                        this.limit_reached = true;
                        break;
                    }
                }

                // remove loaded items from buffer
                for (var i = 0; i < loaded_count; i++) {
                    this.buffer.shift();
                }

                if (this.limit_reached) {
                    return;
                }

                for (var i = 0; i < this.concurrent_files; i++) {

                    var archive_file = true;
                    var ajax_file = JSON_BASE_URL + this.current_year + '/' +
                        pad_num(this.current_month, 2) + '/' + pad_num(this.current_day, 2) + '/archive.json';

                    // Do all initial files before going through archive files
                    for (var j = 0; j < this.initial_files.length; j++) {

                        var file = this.initial_files[j];
                        if (file.do_file && !file.file_done) {

                            ajax_file = file.url;
                            archive_file = false;
                            this.initial_files[j].file_done = true;
                            break;
                        }
                    }

                    if (this.initial_files_item_num == 0 && archive_file) {
                        // Archive files have begun and the initial item num can be set
                        // (for example, 12 matrix + 4 bottom = 16)
                        // Helps in removing duplicates after each archive file load
                        this.initial_files_item_num = this.items.length;
                    }

                    getAjax(ajax_file + '?no_cache=' + CACHEBUST, this.content_loaded);

                    // skip going back a day if not doing archive file yet
                    if (!archive_file) {
                        return;
                    }

                    // Back one day, whether successful ajax or not
                    var month_or_year_change = false;

                    this.current_day--;
                    if (this.current_day <= 0) {
                        this.current_month--;
                        month_or_year_change = true;
                    }

                    if (this.current_month <= 0) {
                        this.current_month = 12;
                        this.current_year--;
                        month_or_year_change = true;
                    }

                    if (month_or_year_change) {
                        this.current_day = daysInMonth(this.current_month, this.current_year);
                    }
                }
            } else {
                this.end_reached = true;
                // Load any remaining buffer items
                for (var i = 0; i < this.buffer.length; i++) {
                    this.items.push(this.buffer[i]);
                }
            }
        },

        // Callback function for getting json of video items
        content_loaded: function (data) {

            var items = [];
            var is_archive_file = false;
            if (data !== false) {
                var json = JSON.parse(data);
                if (typeof json['video_political'] !== 'undefined') {
                    items = json['video_political'];

                    //CHECK IF CONFIG NODE EXISTS IN FEED
                    if (typeof json['configs'] !== 'undefined') {
                        //OVERRIDES OBJECT ATTR
                        this.items_per_page = json['configs']['init_num_videos'];

                        //permalinks we automatically add 4
                        /*if( document.querySelectorAll("body.video-perma").length > 0 ){
                            this.items_per_page = parseInt(this.items_per_page) + 4;
                        }*/

                    }

                } else if (typeof json['video_political_bottom'] !== 'undefined') {
                    items = json['video_political_bottom'];
                }
            }

            if (this.initial_files_item_num > 0) {
                // initial items are loaded, so it's an archive file
                // data is present or not
                // increment files_loaded
                is_archive_file = true;
                if (typeof json !== 'undefined') {
                    items = json['feed']['item'];
                    for (var i = 0; i < items.length; i++) {
                        this.concurrent_buffer.push(items[i]);
                    }
                }

                this.files_loaded++;
                // If all concurrent files are loaded, allow load_content to run
                if (this.files_loaded < this.concurrent_files) {
                    return;
                } else {
                    this.files_loaded = 0;
                }

                items = this.concurrent_buffer;
                this.concurrent_buffer = [];
                // Sort finished concurrent buffer items by date
                items.sort(function (a, b) {
                    var a_d = a.date_posted.split('/');
                    var b_d = b.date_posted.split('/');
                    var a_df = a_d[2] + '-' + a_d[0] + '-' + a_d[1];
                    var b_df = b_d[2] + '-' + b_d[0] + '-' + b_d[1];
                    var a_dt = new Date(a_df);
                    var b_dt = new Date(b_df);
                    if (a_dt > b_dt) {
                        return -1;
                    }
                    if (a_dt < b_dt) {
                        return 1;
                    }

                    return 0;
                });
            }

            if (items.length > 0) {
                for (var i = 0; i < items.length; i++) {

                    // Only add to buffer if item is archive file
                    var found_match = false;
                    if (is_archive_file) {
                        for (var j = 0; j < this.initial_files_item_num; j++) {

                            if (typeof this.items[j] !== 'undefined' && this.items[j].link == items[i].link) {
                                found_match = true;
                            }
                        }
                    }

                    if (!found_match) {
                        this.buffer.push(items[i]);
                    }
                }
            }

            // Call this again to make sure enough items loaded
            // Must use setTimeout to avoid going over stack limit for recursion in IE
            //this.load_content();
            setTimeout(this.load_content, 0);
        },

        bg_image: function (item) {

            if(item.image_wp){
                return 'background-image:url(' + item.image_wp + ');';
            }

            return 'background-image:url(' + item.image + ');';
        },

        formatted_date: function (ts) {

            var d = new Date(parseInt(ts) * 1000);
            var day = d.getDate();

            return MONTH_NAMES[d.getMonth()] + ' ' + num_with_ordinal_suffix(day) + ', ' + d.getFullYear();
        }
    },
}
</script>